import { Pressable, Text, View } from 'react-native'
import { colors } from '@chillout/core'

interface RoleToggleProps {
  label: string
  value: 'staff' | 'manager'
  staffLabel: string
  managerLabel: string
  onChange: (value: 'staff' | 'manager') => void
}

export function RoleToggle({ label, value, staffLabel, managerLabel, onChange }: RoleToggleProps) {
  return (
    <View>
      <Text className="mb-2 text-sm font-medium text-primary">{label}</Text>
      <View className="flex-row gap-6">
        <RadioOption
          label={staffLabel}
          selected={value === 'staff'}
          onPress={() => onChange('staff')}
        />
        <RadioOption
          label={managerLabel}
          selected={value === 'manager'}
          onPress={() => onChange('manager')}
        />
      </View>
    </View>
  )
}

interface RadioOptionProps {
  label: string
  selected: boolean
  onPress: () => void
}

function RadioOption({ label, selected, onPress }: RadioOptionProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="radio"
      accessibilityState={{ checked: selected }}
      className="flex-row items-center gap-2"
    >
      <View
        className="h-4 w-4 items-center justify-center rounded-full border"
        style={{
          borderColor: selected ? colors.accent.DEFAULT : colors.border,
          backgroundColor: selected ? colors.accent.DEFAULT : 'transparent',
        }}
      >
        {selected ? <View className="h-1.5 w-1.5 rounded-full bg-white" /> : null}
      </View>
      <Text className={`text-sm font-medium ${selected ? 'text-accent' : 'text-primary'}`}>
        {label}
      </Text>
    </Pressable>
  )
}